import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

export interface UserLocationAssignment {
  id: string
  name: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = (t: string): any => (supabase as any).from(t)

/**
 * Returns a Map<user_id, Array<{id, name}>> of explicit location assignments
 * for every user in the tenant. Users with NO entry in the map are
 * unrestricted (or owner/admin — caller decides the display).
 */
export function useUserLocationAssignments(tenantId: string) {
  return useQuery({
    queryKey: ['user-location-assignments', tenantId],
    enabled: !!tenantId,
    queryFn: async () => {
      const { data, error } = await db('user_locations')
        .select('user_id, location_id, warehouses(name)')
        .eq('tenant_id', tenantId)
      if (error) throw error

      const rows = (data ?? []) as Array<{
        user_id: string
        location_id: string
        warehouses: { name: string } | null
      }>

      const map = new Map<string, UserLocationAssignment[]>()
      for (const row of rows) {
        const list = map.get(row.user_id) ?? []
        list.push({ id: row.location_id, name: row.warehouses?.name ?? '—' })
        map.set(row.user_id, list)
      }
      return map
    },
  })
}
